// terms: {
//       name: string
//       label: string
//       custom: boolean
//       content: string
//     }
//

import type { QuoteDocument } from 'paintscout'

import type { UpdateableTerms } from '../../index'

export function updateTerms(args: { quote: QuoteDocument; terms: UpdateableTerms }): QuoteDocument {
  const { quote, terms } = args
  const convertedTerms = convertTerms(terms)

  return {
    ...quote,
    terms: {
      ...convertedTerms
    }
  }
}

function convertTerms(
  terms: UpdateableTerms
): {
  name: string
  label: string
  custom: boolean
  content: string
  disabled: boolean
} {
  return {
    name: terms.name,
    label: terms.label,
    custom: terms.custom,
    content: terms.content,
    disabled: terms.disabled
  }
}
